import React,{useState,useEffect} from "react";
import {Button, CircularProgress, Dialog, Grid, Stack, TextField, Typography} from "@mui/material";
import Appbar from "./Appbar";
import MenuList from "./MenuList";
import axios from "axios";
import ErrorMsg from "./msg/ErrorMsg";
import SuccsMsg from "./msg/SuccsMsg";
import {Navigate} from "react-router-dom";

const AddNewProduct=()=>{
    const [loading , setLoading] = useState(false);
    const [customerName , setCustomerName] = useState("");
    const [customerPhone , setCustomerPhone] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [succsMsg, setSuccsMsg] = useState("");
    const handle_btn_addcustomer=()=>{
        setLoading(true);
        const data={
            name : customerName,
            phone : customerPhone,
            token : localStorage.getItem("adminlogintoken"),
        }
        axios.post("/api/addcustomer.php",data)
            .then(response=>{
                setLoading(false);
                if (response.status === 200)
                    if (response.data.error === false) {
                        setSuccsMsg(response.data.message);
                        setCustomerName("");
                        setCustomerPhone("");
                    }
                    else
                        setErrorMsg(response.data.message);
                else
                    setErrorMsg(response.data.message);
            })
            .catch(error=>{
                setLoading(false);
                setErrorMsg("ارتباط با سرور قطع شده است");
            })
    }
    const Redirect = () => {
        return (<Navigate replace to="/login"/>)
    }
    return(
        <div>
            {localStorage.getItem("adminlogintoken") === "" ? <Redirect/> : ''}
            {localStorage.getItem("adminlogintoken") === null ? <Redirect/> : ''}
            {errorMsg !== '' ? <ErrorMsg message={errorMsg} openn={true} seterrormsg={setErrorMsg}/> : ''}
            {succsMsg !== '' ? <SuccsMsg message={succsMsg} openn={true} setsuccsmsg={setSuccsMsg}/> : ''}
            <Grid container spacing={2} sx={{marginTop: 0}}>
                <Grid item xs={12} md={10} sx={{backgroundColor: "#ffffff", minHeight: "100vh"}}>
                    <Appbar/>
                    <div dir={"rtl"} style={{
                        paddingRight: "20px",
                        paddingLeft: "20px",
                        marginBottom: "60px",
                        marginTop: "20px",
                        display: "flex", justifyContent: "center", justifyItems: "center"
                    }}>
                        <Stack sx={{maxWidth: "500px",}}>
                            <Typography sx={{
                                textAlign: "right",
                                color: "black",
                                fontSize: "15px",
                            }}>
                                نام مشتری
                            </Typography>
                            <TextField
                                color={"info"}
                                autoComplete="off"
                                fullWidth
                                value={customerName}
                                onChange={(e)=>setCustomerName(e.target.value)}
                                size={"small"}
                                sx={{
                                    marginTop: 1,
                                    marginBottom: 1,
                                }}
                                variant="outlined"/>
                            <Typography sx={{
                                textAlign: "right",
                                color: "black",
                                fontSize: "15px",
                            }}>
                                شماره تماس
                            </Typography>
                            <TextField
                                color={"info"}
                                autoComplete="off"
                                fullWidth
                                type={"number"}
                                value={customerPhone}
                                onChange={(e)=>setCustomerPhone(e.target.value)}
                                size={"small"}
                                sx={{
                                    marginTop: 1,
                                    marginBottom: 1,
                                }}
                                variant="outlined"/>
                            <Button
                                variant="contained"
                                fullWidth
                                size={"large"}
                                onClick={handle_btn_addcustomer}
                                sx={{
                                    backgroundColor: "gold", '&:hover': {
                                        backgroundColor: "#dedede"
                                    }, marginTop: 2, color: "#000000"
                                }}>افزودن مشتری جدید</Button>
                        </Stack>
                    </div>
                </Grid>
                <Grid item xs={0} md={2} sx={{
                    backgroundColor: '#2b2b2b',
                    minHeight: "100vh",
                    display: {xs: "none", md: "block"}
                }}>
                    <MenuList/>
                </Grid>
            </Grid>
            <Dialog
                open={loading}
                scroll="paper">
                <CircularProgress sx={{margin: 2}}/>
            </Dialog>
        </div>
    )
}
export default AddNewProduct;